import { Observable } from 'rxjs';

import { RestfulModel, Store } from 'app/model';
import { MidFilter } from 'app/model/mid-filter';
import { StoreFilters } from 'app/model/seam/store-filters';

import { ModelWithoutId } from 'app/type';

import { RestfulApiService } from './restful-api.service';

export interface HistoryResponse extends RestfulModel {
    name: string;
    filters: MidFilter[];
    storeId: Store;
}

export class StoreFiltersService extends RestfulApiService<StoreFilters, Store> {
    public deleteFilter(filter: StoreFilters, store: Store): Observable<void> {
        return this.delete(filter, store);
    }

    public saveFilter(filter: ModelWithoutId<StoreFilters>, store: Store): Observable<StoreFilters> {
        return this.create(filter, store);
    }

    public editFilter(filter: StoreFilters, store: Store): Observable<StoreFilters> {
        return this.update(filter, store);
    }

    protected getFormName(): string {
        return 'store_filters';
    }

    protected getPath(parent?: Store | undefined): string {
        if (!parent) {
            throw new Error('Parent store is required in StoreFilterService');
        }

        return `stores/${parent.id}/filters`;
    }
}

export const storeFiltersService = new StoreFiltersService();
